import {
  Enum_Client_Civilite,
  Enum_Client_Civilitelivraison,
  Enum_Commande_Methodepaiement,
  Maybe,
  Scalars
} from '../../graphql/generated/graphql';
import { MainFormState } from '../forms/form.def';
import { ID } from '../typeDef';

export const civiliteDef = [
  {
    id: Enum_Client_Civilite.Madame,
    name: 'Madame'
  },
  { id: Enum_Client_Civilite.Monsieur, name: 'Monsieur' }
];

interface PaiementMethodeDef {
  id: Enum_Commande_Methodepaiement;
  name: string;
}

export const paiementMethodeDef: PaiementMethodeDef[] = [
  { id: Enum_Commande_Methodepaiement.Cheque, name: 'Chèques' },
  { id: Enum_Commande_Methodepaiement.Especes, name: 'Espèces' },
  { id: Enum_Commande_Methodepaiement.Cb, name: 'Carte Bancaire' },
  {
    id: Enum_Commande_Methodepaiement.MandatAdministratif,
    name: 'Mandat Administratif'
  },
  {
    id: Enum_Commande_Methodepaiement.Virement,
    name: 'Virement'
  }
];
export const publicPaiementMethod = [
  { id: Enum_Commande_Methodepaiement.Cb, name: 'Carte Bancaire' }
];

export const initLivraison = {
  civilitelivraison: null,
  prenomlivraison: null,
  nomlivraison: null,
  adresselivraison: null,
  cplivraison: null,
  villelivraison: null,
  mobilelivraison: null
};
export const initLivraisonError = {
  civilitelivraison: false,
  prenomlivraison: false,
  nomlivraison: false,
  adresselivraison: false,
  cplivraison: false,
  villelivraison: false,
  mobilelivraison: false
};

export type ClientInput = Omit<ClientDef, 'id'>;

export const initClientInput: ClientInput = {
  civilite: null,
  nom: null,
  prenom: null,
  adressefacturation: null,
  cpfacturation: null,
  villefacturation: null,
  tel: null,
  mail: null,
  livraisonhorslycee: false,
  ...initLivraison,
  clientpro: false,
  nomsociete: null,
  policy: false
};

export type ClientDef = {
  id: ID;
  prenom: Scalars['String'];
  nom: Scalars['String'];
  adressefacturation: Scalars['String'];
  villefacturation: Scalars['String'];
  mail: Scalars['String'];
  livraisonhorslycee?: Maybe<Scalars['Boolean']>;
  adresselivraison?: Maybe<Scalars['String']>;
  villelivraison?: Maybe<Scalars['String']>;
  clientpro?: Maybe<Scalars['Boolean']>;
  nomsociete?: Maybe<Scalars['String']>;
  policy: Scalars['Boolean'];
  tel: Scalars['String'];
  cpfacturation: Scalars['String'];
  cplivraison?: Maybe<Scalars['String']>;
  civilite: Enum_Client_Civilite;
  civilitelivraison?: Maybe<Enum_Client_Civilitelivraison>;
  nomlivraison?: Maybe<Scalars['String']>;
  prenomlivraison?: Maybe<Scalars['String']>;
  mobilelivraison?: Maybe<Scalars['String']>;
  relaisid?: Maybe<Scalars['String']>;
  nompointrelais?: Maybe<Scalars['String']>;
  isrelais?: Maybe<Scalars['Boolean']>;
  affilie?: Maybe<Scalars['Boolean']>;
};
export interface ClientFormValue extends ClientInput {
  methodepaiement?: Enum_Commande_Methodepaiement;
}

export type ClientFormState = MainFormState<
  ClientFormValue,
  {
    nompointrelais?: string;
    affilie?: boolean;
  }
>;

export type ClientInputUpdate = ClientInput & { id: ID };

export interface ClientName {
  prenom?: string;
  nom?: string;
}
